 class FreeShippingBar {
    constructor({ threshold = 100, targetSelector = '.js-free-shipping-bar' }) {
      this.threshold = threshold;
      this.targetSelector = targetSelector;
      this.cartTotal = 0;

      this.init();
    }

    init() {
      this.injectBar();
      this.fetchAndUpdate();

      document.addEventListener('cartAdded', () => this.fetchAndUpdate());
      document.addEventListener('cartUpdated', () => this.fetchAndUpdate());
    }

    injectBar() {
  const containers = document.querySelectorAll(this.targetSelector);
  if (!containers.length) return;

  containers.forEach(container => {
    // Evită injectarea dacă deja a fost făcută (opțional)
    if (container.querySelector('.fs-bar__message')) return;

    container.innerHTML = `
      <div class="fs-bar__message">
        <span class="fs-bar__text">🛒 Calculăm transportul gratuit...</span>
      </div>
      <div class="fs-bar__progress-wrapper">
        <div class="fs-bar__progress">
          <div class="fs-bar__progress-fill"></div>
          <div class="fs-bar__progress-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 12 12">
              <path d="M5.56445.761719C5.69336.503906 5.90104.375 6.1875.375s.49414.128906.62305.386719L8.20703 3.59766l3.13677.47265c.2864.02865.4726.17904.5585.45117.086.27214.0287.50847-.1718.70899L9.45312 7.44336l.53711 3.13674c.04297.2721-.05013.487-.27929.6445-.22917.1719-.4655.1934-.70899.0645L6.1875 9.82812 3.37305 11.2891c-.24349.1432-.47982.1289-.70899-.043-.22916-.1719-.32226-.3939-.27929-.666l.53711-3.13674L.644531 5.23047C.44401 5.02995.386719 4.79362.472656 4.52148c.085938-.27213.272136-.42252.558594-.45117l3.13672-.47265L5.56445.761719z"/>
            </svg>
          </div>
        </div>
      </div>
    `;
  });
}

    updateBarMessage() {
      const containers = document.querySelectorAll(this.targetSelector);
      if (!containers.length) return;
    
      let rawPercentage = (this.cartTotal / this.threshold) * 100;
      let maxPercentage = window.innerWidth < 768 ? 97 : 100;
      const percentage = Math.min(maxPercentage, rawPercentage).toFixed(2);
    
      containers.forEach(container => {
        const messageEl = container.querySelector('.fs-bar__text');
        const fillEl = container.querySelector('.fs-bar__progress-fill');
        const iconEl = container.querySelector('.fs-bar__progress-icon');
    
        if (messageEl && fillEl) {
          fillEl.style.width = `${percentage}%`;
          if (iconEl) iconEl.style.left = `${percentage}%`;
    
          if (this.cartTotal >= this.threshold) {
            messageEl.innerHTML = `🎉 <strong>Felicitări!</strong> Ai transport <strong>gratuit</strong>!`;
          } else {
            const remaining = (this.threshold - this.cartTotal).toFixed(2);
            messageEl.innerHTML = `Adaugă <strong>${remaining} RON</strong> pentru a beneficia de <strong>transport gratuit</strong>`;
          }
        }
      });
    }

    async fetchAndUpdate() {
      try {
        const response = await fetch('/cart.js');
        const data = await response.json();
        this.cartTotal = data.total_price / 100;
 
        this.updateBarMessage();
      } catch (error) {
        console.error('Eroare la preluarea coșului:', error);
      }
    }
  }

let freeShippingBarInstance;

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
      freeShippingBarInstance.injectBar();
  }, 1000);
  
  freeShippingBarInstance = new FreeShippingBar({
    threshold: window.FREE_SHIPPING_THRESHOLD || 500,
    targetSelector: '.js-free-shipping-bar'
  });

  // Ascultă click pe butonul Releasit (Comandă rapidă)
  document.addEventListener('click', (e) => {
    if (e.target.closest('#_rsi-buy-now-button')) {
      console.log('ai dat click');
      setTimeout(() => {
        freeShippingBarInstance.fetchAndUpdate();
      }, 500); // mic delay pentru a permite update-ul de coș
    }
  });
});